import OnboardLayout from "./onboard-layout";
import styles from "../styles/signup-layout.module.scss";
import { ReactNode } from "react";

export type SignupLayoutProps = {
    children: any;
    description: string | ReactNode;
    descriptionBold?: boolean;
    activeTabOrder?: number;
    className?: string;
};

const SignupLayout = (props: SignupLayoutProps) => {
    return (
        <OnboardLayout hideBackgroundImg hideLogo smallLogo={true}>
            <div className={styles.contentContainer + (props.className ? ' ' + props.className : '')} >
                <h1 className={props.descriptionBold ?  styles.signupHeaderTwo : styles.signupHeaderOne}>{props.description}</h1>
                {props.children}
            </div>
        </OnboardLayout>
    );
};

export default SignupLayout;
